<template>
    <div>
        <Heading class="tw-mt-10" title="Vielen Dank für Deine Anfrage!" :size="1" />
        <Heading title="So geht es jetzt weiter:" :size="2" />
        <div v-if="isPhoneInquiry">
            <next-steps-snippet :number="1" >
                Wir rufen Dich bald an, um Deine Wünsche zu besprechen.
                <custom-button @click="loadCalendly()">
                    Termin selbst wählen
                </custom-button>
            </next-steps-snippet>
            <next-steps-snippet :number="2" >
                Dein lokaler Reiseexperte plant Deine individuelle Traumreise.
            </next-steps-snippet>
            <next-steps-snippet :number="3" >
                Sichere Buchung & Bezahlung Deiner Pauschalreise - vollständig abgesichert.
            </next-steps-snippet>
        </div>
        <div v-else>
            <next-steps-snippet :number="1" >
                Dein lokaler Reiseexperte meldet sich in Kürze bei Dir.
            </next-steps-snippet>
            <next-steps-snippet :number="2" >
                Gemeinsam plant Ihr Deine Traumreise. Deine Wünsche kannst Du auch telefonisch besprechen.
            </next-steps-snippet>
            <next-steps-snippet :number="3" >
                Sichere Buchung & Bezahlung Deiner Pauschalreise - vollständig abgesichert.
            </next-steps-snippet>
        </div>
    </div>
</template>

<script>
import CustomButton from "../components/baseComponents/CustomButton.vue";
import NextStepsSnippet from "../components/successScreenComponents/NextStepsSnippet.vue";
import { mapGetters } from 'vuex';

export default {
    name: 'SuccessPage',
    components: {NextStepsSnippet, CustomButton},
    computed: {
        ...mapGetters({
            country: 'tour/country',
            tour: 'tour/route'
        }),
        isPhoneInquiry() {
            return this.country?.mainCountry.inquiryType === 'phone-inquiry' || 
                   this.tour?.mainCountry.inquiryType === 'phone-inquiry';
        }
    },
    methods: {
        loadCalendly() {
            document.location.href = 'https://calendly.com/anna-moser-wedesigntrips/telefonat-mit-anna';
        },
    },
    mounted() {
        this.$store.commit('tour/setPending', false);
    }
}

</script>

<style scoped>

</style>